module.exports = __webpack_public_path__ + "static/img/sitting-8.51d9e69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sitting-8.png
// module id = 443
// module chunks = 169